export default __webpack_public_path__ + "8d222141a7279a5bd97a8ad7614e95e3.jpg";